import { Types } from './types';

const initialState = {
    dataListPackage: {
        paging: {},
        rows: [],
    },
    dataListAccumulation: {
        paging: {},
        rows: [],
        package_data: {}
    },
    dataListTransaction: {
        paging: {},
        rows: [],
    }
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_PACKAGE:
            return {
                ...newState,
                dataListPackage: action.payload
            }
        case Types.SAVE_LIST_ACCUMULATION:
            return {
                ...newState,
                dataListAccumulation: action.payload
            }
        case Types.SAVE_LIST_TRANSACTION:
            return {
                ...newState,
                dataListTransaction: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
